export const ConsolidationTypeMap = {
  SIZE_TYPE: "SIZE_TYPE",
  STATE: "STATE",
} as const;

export type ConsolidationType =
  (typeof ConsolidationTypeMap)[keyof typeof ConsolidationTypeMap];

/**
 * How a placement is grouped when a contract is imported with consolidation.
 * `key` is what bookings are grouped on (and what is stored on the
 * consolidation record); `label` is what the user sees for the group;
 * `placementName` is what the whitelist is matched against.
 */
export interface ConsolidationGroup {
  key: string;
  label: string;
  placementName: string;
}
